<template>
    <div>
        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>

        <div v-else>
            <vue-headful :title="'Distribute Trainng Course(s)' + (course ? ': '+course.course_name : '') + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/training-courses`">
                            <i class="fa fa-life-ring"></i> Training Courses
                        </router-link>
                    </li>
                    <template v-if="course">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="'/training-courses/view/' + (course.training_course_id ? course.training_course_id : course.id)">
                            {{ course.course_name }}
                        </router-link>
                    </li>
                    <li class="breadcrumb-item font-weight-light" v-if="course.employee_id">
                        <router-link :to="`/training-courses/employee/${course.id}/view`">
                            {{ course.FirstName }} {{ course.LastName }}
                        </router-link>
                    </li>
                    </template>
                    <li class="breadcrumb-item active">
                        Send {{ Method }} Blast
                    </li>
                </ol>
            </h4>

            <div v-if="textSuspended" class="alert alert-danger">
                MeritEHS Texting has been temporarily suspended due to regulatory compliance changes (A2P 10DL) by US Carriers. While we await the approval of our sending application, our texting feature must be paused as these Carriers will reject texts without compliance approval.<br/><br/>

                We at the Merit Team are doing everything we can to expedite this approval, and we will provide email updates when available.
            </div>

            <div class="row mb-3">
                <div class="col-lg-4 mb-lg-0 mb-2">
                    <div class="card">
                        <div class="card-header">
                            <strong>Sending Limits</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">Remaining {{ Method }} Credits:</div>
                                <div class="col-lg-3">{{ this['monthly_'+this.method+'_limit'] }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Total {{ Method }}s Sent MTD:</div>
                                <div class="col-lg-3">{{ this['total_'+this.method+'s_sent_mtd'] }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Total {{ Method }}s Sent All Time:</div>
                                <div class="col-lg-3">{{ this['total_'+this.method+'s_sent_all'] }}</div>
                            </div>

                            <router-link to="/billing">Purchase {{ Method }} Credits</router-link>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-lg-0 mb-2">
                    <div class="card">
                        <div class="card-header">
                            <strong>Confirm {{ Method }} Blast</strong>
                        </div>
                        <div class="card-body">
                            <p>You are about to {{ Method }} {{ this.totalEmployeesSelected }} employee(s).</p>

                            <button class="btn btn-sm btn-warning" v-on:click="postDistribute()" v-if="!textSuspended" :disabled="this.totalEmployeesSelected === 0 || sending">Send {{ Method }} Blast</button>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4 mb-lg-0 mb-2" v-if="course || employee || jobsite">
                    <div class="card" v-if="course">
                        <div class="card-header">
                            <strong>Training Course</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">Course</div>
                                <div class="col-lg-7">{{ course.course_name }}</div>
                            </div>
                            <div class="row mb-2" v-if="course.employee_id">
                                <div class="col text-muted">Employee</div>
                                <div class="col-lg-7">{{ course.FirstName }} {{ course.LastName }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card" v-else-if="employee">
                        <div class="card-header">
                            <strong>Employee</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">Name</div>
                                <div class="col-lg-7">{{ employee.FirstName }} {{ employee.LastName }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Employee#</div>
                                <div class="col-lg-7">{{ employee.EmployeeNumber }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="card" v-else-if="jobsite">
                        <div class="card-header">
                            <strong>Jobsite</strong>
                        </div>
                        <div class="card-body">
                            <div class="row mb-2">
                                <div class="col text-muted">Name</div>
                                <div class="col-lg-7">{{ jobsite.JobsiteName }}</div>
                            </div>
                            <div class="row mb-2">
                                <div class="col text-muted">Number</div>
                                <div class="col-lg-7">{{ jobsite.JobsiteNumber }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="alert alert-warning" v-if="method === 'text'">
                All Text messages will come from the number: <strong>{{ textNumber }}</strong>. You and your employees can save this number as a contact in your phone.
            </div>

            <div class="card mb-3">
                <div class="card-header">
                    <strong>Select Pending Training Courses to Send ({{ totalSelected }})</strong>
                </div>
                <div class="card-body">

                    <div class="alert alert-danger mb-2" v-if="errors.emp_training_course_id">
                        {{ errors.emp_training_course_id }} Visit your <router-link to="/billing">Billing Settings</router-link> to purchase more credits
                    </div>

                    <v-client-table name="trainingCourseDistributeList" ref="trainingCourseDistributeList" :data="courses" :columns="columns" :options="options">

                        <template slot="h__id">
                             <input type='checkbox' @click='selectAll()' />
                        </template>

                        <template slot="id" slot-scope="props">
                            <b-form-checkbox v-model="courseIds" :value="props.row.id" plain :disabled="disableRow(props.row)" :title="disableTitle(props.row)" />
                        </template>

                        <router-link slot="course_name" slot-scope="props" :to="`/training-courses/view/${props.row.training_course_id}`" title="View Training Course">
                            {{ props.row.course_name }}
                        </router-link>

                        <router-link slot="LastName" slot-scope="props" :to="`/employees/view/${props.row.employee_id}`" title="View Employee">
                            {{ props.row.FirstName }} {{ props.row.LastName }}
                        </router-link>

                        <template slot="last_texted_at" slot-scope="props">
                            <span v-if="props.row.last_texted_at">{{ props.row.last_texted_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                        </template>

                        <template slot="last_emailed_at" slot-scope="props">
                            <span v-if="props.row.last_emailed_at">{{ props.row.last_emailed_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}</span>
                        </template>

                    </v-client-table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                loading: true,
                sending: false,
                userTimezone: this.$store.state.user.timezone,
                method: this.$route.params.method,
                course: null,
                employee: null,
                jobsite: null,
                select_all: false,
                courseIds: [],
                employeeIds: [],
                totalFiltered: null,
                errors: {},
                monthly_email_limit: null,
                total_emails_sent_mtd: null,
                total_emails_sent_all: null,
                monthly_text_limit: null,
                total_texts_sent_mtd: null,
                total_texts_sent_all: null,

                columns: ['id', 'course_name', 'LastName', 'EmployeeNumber', 'position', 'email', 'Phone', 'last_emailed_at', 'last_texted_at'],
                options: {
                    sortable: ['course_name', 'LastName', 'EmployeeNumber', 'position', 'email', 'Phone', 'last_emailed_at', 'last_texted_at'],
                    headings: {
                        course_name: 'Course',
                        LastName: 'Employee',
                        position: 'Position',
                        EmployeeNumber: 'Employee Number',
                        email: 'Email',
                        Phone: 'Phone#',
                        last_emailed_at: 'Last Emailed',
                        last_texted_at: 'Last Texted',
                    },
                    orderBy: {
                        ascending: true,
                        column: 'employee.LastName',
                    },
                    uniqueKey: 'id',
                },
            }
        },

        watch: {
            appliedFilter(newVal, oldVal){
                //Call the helper
                this.checkForAppliedFilter();
            },
        },

        computed: {
            totalSelected(){
                //Return the Employees count
                return this.courseIds.length;
            },

            totalEmployeesSelected(){
                //SEtup
                var employeeIds = [];

                //We want to count unique employees
                for (var i = this.courses.length - 1; i >= 0; i--)
                {
                    //Check if the Course ID is selected
                    if(this.courseIds.indexOf(this.courses[i].id) !== -1 && employeeIds.indexOf(this.courses[i].employee_id) === -1)
                    {
                        employeeIds.push(this.courses[i].employee_id);
                    }
                }

                //Return the Employees count
                return employeeIds.length;
            },

            Method(){
                return this.method.charAt(0).toUpperCase() + this.method.slice(1);
            },

            textNumber(){
                //Setup
                var phone = this.$root.meritehs_number.replace('+1', '');

                //Clean it
                var formatted = '+1 ' + phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');

                //SEnd it
                return formatted;
            },

            textSuspended(){
                //Send it
                return this.Method === 'Text' && (this.$root.text_suspended === true || this.$root.text_suspended === 'true') ? true : false;
            }

        },

        methods: {

            getDistribute() {
                //Setup
                var filters = {};

                //Add all the Query param
                var keys = Object.keys(this.$route.query);

                //Loop and Append
                for (var i = keys.length - 1; i >= 0; i--)
                {
                    filters[keys[i]] = this.$route.query[keys[i]];
                }

                //Get the data
                this.$http
                    .get('/training-courses/distribute/'+this.method, filters)
                    .then(response => {
                        //Set all the data
                        this.course = response.data.course;
                        this.employee = response.data.employee;
                        this.jobsite = response.data.jobsite;
                        this.courses = response.data.courses;
                        this.monthly_email_limit = response.data.monthly_email_limit;
                        this.total_emails_sent_mtd = response.data.total_emails_sent_mtd;
                        this.total_emails_sent_all = response.data.total_emails_sent_all;
                        this.monthly_text_limit = response.data.monthly_text_limit;
                        this.total_texts_sent_mtd = response.data.total_texts_sent_mtd;
                        this.total_texts_sent_all = response.data.total_texts_sent_all;
                    })
                    .catch(response => {

                    })
                    .then(() => {
                        //Set loading
                        this.loading = false;
                    });
            },

            postDistribute() {
                //Sending
                this.sending = true;

                //Reset the Errors
                this.errors = {};

                //Setup the payload
                var payload = {
                    select_all: this.select_all,
                    courses: this.courseIds
                };

                //Get the data
                this.$http
                    .post('/training-courses/distribute/'+this.method, payload)
                    .then(response => {
                        //Send to the View
                        if(this.$route.query.emp_course_id)
                        {
                            this.$router.push('/training-courses/employee/'+this.$route.query.emp_course_id+'/view');
                        }
                        else if (this.$route.query.training_course_id)
                        {
                            this.$router.push('/training-courses/view/' + this.$route.query.training_course_id);
                        }
                        else if (this.$route.query.jobsite_id)
                        {
                            this.$router.push('/jobsites/view/' + this.$route.query.jobsite_id);
                        }
                        else if (this.$route.query.employee_id)
                        {
                            this.$router.push('/employees/view/' + this.$route.query.employee_id);
                        }
                        else
                        {
                            this.$router.push('/training-courses/pending');
                        }

                    })
                    .catch(error => {
                        //Sending
                        this.sending = false;

                        //Check for error
                        if(error.response.status === 422)
                        {
                            //Display validation errors
                            this.errors = error.response.data;
                        }
                    })
                    .then(() => {
                        //Reset
                        this.sending = false;
                    });
            },

            selectAll(){
                //Set it
                this.select_all = !this.select_all;

                //Check for false
                if(!this.select_all)
                {
                    //Reset
                    this.courseIds = [];

                    //Stop Here
                    return;
                }

                //Add All
                for (var i = this.courses.length - 1; i >= 0; i--)
                {
                    //Check for Skip
                    if(this.disableRow(this.courses[i]))
                    {
                        continue;
                    }

                    //Push it
                    this.courseIds.push(this.courses[i].id);
                }
            },

            disableRow(row){
                //Check for public training course
                if(!row.course_key)
                {
                    return true;
                }

                //If we are texting, make sure we have a phone
                if( this.method === 'text' && (row.Phone == null || row.Phone == '') )
                {
                    return true;
                }

                //If we are texting, make sure we have a phone
                if( this.method === 'email' && (row.email == null || row.email == '') )
                {
                    return true;
                }

                //Default
                return false;
            },

            disableTitle(row){
                //Check for public training course
                if(!row.course_key)
                {
                    return 'Training Course does not have public access turned out. Turn on Public access to distribute course links.';
                }

                //If we are texting, make sure we have a phone
                if( this.method === 'text' && (row.Phone == null || row.Phone == '') )
                {
                    return 'Employee does not have a phone# on record.';
                }

                //If we are texting, make sure we have a phone
                if( this.method === 'email' && (row.email == null || row.email == '') )
                {
                    return 'Employee does not have an email address on record';
                }

                //Default
                return '';
            },

        },
        mounted() {
            //Get the Training Course
            this.getDistribute();
        }
    }
</script>
